import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { ILegalView } from "../model/LegalView";
import LegalViewMapper from "../service/LegalViewMapper";
import LegalViewParamMapper from "../service/LegalViewParamMapper";

export default class GetAllLegalViewsInteractor {
  private resource: GetAllResourceEntriesInteractor<ILegalView>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.endpointBasePath,
      LegalViewMapper,
      LegalViewParamMapper
    );
  }
}
